import {jsx as _jsx} from "react/jsx-runtime";
import {cn} from '../cn'

const Code = ({className, ...props}) => (
  _jsx('svg', {
    viewBox: "0 0 24 24"   ,
    'aria-hidden': "true",
    focusable: "false",
    ...props,
    className: cn(
      'inline-block h-[1em] w-[1em] shrink-0 select-none fill-current text-[24px]',
      className
    ),
 children: 
    _jsx('path', { d: "M9.4 16.6 4.8 12l4.6-4.6L8 6l-6 6 6 6zm5.2 0 4.6-4.6-4.6-4.6L16 6l6 6-6 6z"            ,} )
  })
)

export default Code
